export const SESSION_STORAGE_LANDING_EVENT_KEY = 'ss_landing_fired';
export const FACEBOOK_CLICK_ID = 'facebook_click_id';
export const CURRENT_GUEST_DATA = 'current_guest_data';
